(function ($) {
    $(document).ready(function () {
        console.log("ready");

        // setBodyPadding();
        createParallax();
        backBtn();
    });

    $(window).on("load", function () {
        console.log("loaded");
        noTitleOnImgHover();
    });

    $(window).on("resize", function () {
        console.log("resize");
    });

    function backBtn() {
        $(".btnBack").on("click", function (event) {
            event.preventDefault();

            let link = $(this).attr("href");

            let referrer = document.referrer;
            let host = window.location.host;

            if (referrer.includes(host)) {
                // window.location.href = referrer;
                history.back();
            } else if (link != "" && link != undefined) {
                window.location.href = link;
            } else {
                window.location.href = window.location.origin;
            }
        });
    }

    function noTitleOnImgHover() {
        $("img").on("mouseenter", function () {
            $this = $(this);
            img_title = $this.attr("title");
            $this.attr("title", "");

            $($this).on("mouseleave", function () {
                $this.attr("title", img_title);
            });
        });
    }

    function setBodyPadding() {
        $("#main").css("padding-top", $("header").height());
    }

    // simpleParallax auf Bildern in .parallax-window sowie dem Hintergrundbild des
    // Parallax-Blocks (blocks/parallax). scale > 1 sorgt für den Bewegungsspielraum,
    // ohne dass der Bildrand sichtbar wird.
    function createParallax() {
        $(".parallax-window img, .tpl-parallax__img").each(function () {
            new simpleParallax(this, {
                scale: 1.3,
                delay: 0.4,
                transition: "cubic-bezier(0,0,0,1)",
            });
        });
    }
})(jQuery);

function sameheight(section, elementsstring) {
    h = 0;
    jQuery(section).each(function () {
        h = 0;
        jQuery(this).find(elementsstring).css("height", "auto");
        jQuery(this)
            .find(elementsstring)
            .each(function () {
                if (jQuery(this).outerHeight() > h) {
                    h = jQuery(this).outerHeight();
                }
            });
        if (h != 0) {
            jQuery(elementsstring).css("height", h);
        }
    });
}
